<template>
    <span>
        <svg v-if="country ==='nl'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#21468b" d="M0 0h640v480H0z" />
            <path fill="#fff" d="M0 0h640v320H0z" />
            <path fill="#ae1c28" d="M0 0h640v160H0z" />
        </svg>

        <svg v-if="country ==='gb'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#012169" d="M0 0h640v480H0z" />
            <path fill="#FFF" d="M75 0l244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z" />
            <path fill="#C8102E" d="M424 281l216 159v40L369 281h55zm-184 20l6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z" />
            <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z" />
            <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" />
        </svg>

        <svg v-if="country ==='de'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#ffce00" d="M0 320h640v160H0z" />
            <path d="M0 0h640v160H0z" />
            <path fill="#d00" d="M0 160h640v160H0z" />
        </svg>

        <svg v-if="country ==='es'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#AA151B" d="M0 0h640v480H0z" />
            <path fill="#F1BF00" d="M0 120h640v240H0z" />
        </svg>

        <svg v-if="country ==='fr'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <g fill-rule="evenodd" stroke-width="1pt">
                <path fill="#fff" d="M0 0h640v480H0z" />
                <path fill="#00267f" d="M0 0h213.3v480H0z" />
                <path fill="#f31830" d="M426.7 0H640v480H426.7z" />
            </g>
        </svg>

        <svg v-if="country ==='it'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <g fill-rule="evenodd" stroke-width="1pt">
                <path fill="#fff" d="M0 0h640v480H0z" />
                <path fill="#009246" d="M0 0h213.3v480H0z" />
                <path fill="#ce2b37" d="M426.7 0H640v480H426.7z" />
            </g>
        </svg>

        <svg v-if="country ==='dk'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#c8102e" d="M0 0h640.1v480H0z" />
            <path fill="#fff" d="M205.7 0h68.6v480h-68.6z" />
            <path fill="#fff" d="M0 205.7h640.1v68.6H0z" />
        </svg>

        <svg v-if="country ==='no'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#ed2939" d="M0 0h640v480H0z" />
            <path fill="#fff" d="M180 0h120v480H180z" />
            <path fill="#fff" d="M0 180h640v120H0z" />
            <path fill="#002664" d="M210 0h60v480h-60z" />
            <path fill="#002664" d="M0 210h640v60H0z" />
        </svg>

        <svg v-if="country ==='se'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <defs>
                <clipPath id="a">
                    <path fill-opacity=".7" d="M-53.4 0h682.6v512H-53.4z" />
                </clipPath>
            </defs>
            <g clip-path="url(#a)" transform="translate(50) scale(.9375)">
                <g fill-rule="evenodd" stroke-width="1pt">
                    <path fill="#006aa7" d="M-121.1.3h256v204.8h-256zm0 306.9h256V512h-256z" />
                    <path fill="#fecc00" d="M-121.1 205h256v102.4h-256z" />
                    <path fill="#fecc00" d="M133.8 0h102.4v512H133.8z" />
                    <path fill="#fecc00" d="M233 205h460.8v102.4H233z" />
                    <path fill="#006aa7" d="M236.2 307.2H697V512H236.2zm0-306.9H697v204.8H236.2z" />
                </g>
            </g>
        </svg>

        <svg v-if="country ==='fi'"
             xmlns="http://www.w3.org/2000/svg"
             :class="`flag-icon flag-icon-${country}`"
             viewBox="0 0 640 480"
        >
            <path fill="#fff" d="M0 0h640v480H0z" />
            <path fill="#003580" d="M0 174.5h640v131H0z" />
            <path fill="#003580" d="M175.5 0h130.9v480h-131z" />
        </svg>

        <svg v-if="country ==='at'"
             :class="`flag-icon flag-icon-${country}`"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 640 480"
        >
            <g fill-rule="evenodd">
                <path fill="#fff" d="M640 480H0V0h640z" />
                <path fill="#c8102e" d="M640 480H0V320h640zm0-319.9H0V.1h640z" />
            </g>
        </svg>

        <svg v-if="country ==='ch'"
             :class="`flag-icon flag-icon-${country}`"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 640 480"
        >
            <g fill-rule="evenodd" stroke-width="1pt">
                <path fill="#d52b1e" d="M0 0h640v480H0z" />
                <g fill="#fff">
                    <path d="M170 195h300v90H170z" />
                    <path d="M275 90h90v300h-90z" />
                </g>
            </g>
        </svg>

        <svg v-if="country ==='us'"
             id="flag-icons-us"
             class="flag-icon"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 640 480"
        >
            <g fill-rule="evenodd">
                <g stroke-width="1pt">
                    <path fill="#bd3d44" d="M0 0h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8V197H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8V512H0z" transform="scale(.9375)" />
                    <path fill="#fff" d="M0 39.4h972.8v39.4H0zm0 78.8h972.8v39.3H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0z" transform="scale(.9375)" />
                </g>
                <path fill="#192f5d" d="M0 0h389.1v275.7H0z" transform="scale(.9375)" />
                <path fill="#fff" d="M32.4 11.8 36 22.7h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0 3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0 3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 39.4l3.5 10.9h11.5L70.6 57 74 67.9l-9-6.7-9.3 6.7L59 57l-9-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7L124 57l-9.3-6.7h11.5zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0 3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0 3.5 10.9h11.5L330 57l3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 66.9 36 78h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H29zm64.9 0 3.5 11h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0 3.6 11H177l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7h11.5zm64.9 0 3.5 11H242l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.4zm64.8 0 3.6 11h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.2-6.7h11.4zm64.9 0 3.5 11h11.5l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zM64.9 94.5l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 122.1 36 133h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0 3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0 3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 149.7l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7H191zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H256zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zM32.4 177.2l3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0 3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0 3.6 11H177l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0 3.5 11H242l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0 3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0 3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 204.8l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 232.4l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7H29zm64.9 0 3.5 10.9h11.5L103 250l3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0 3.6 10.9H177l-9 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7h11.5zm64.9 0 3.5 10.9H242l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0 3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.2-6.7h11.4zm64.9 0 3.5 10.9h11.5l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.5z" transform="scale(.9375)" />
            </g>
        </svg>

        <svg v-if="country === 'au'"
             :class="`flag-icon flag-icon-${country}`"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 640 480"
        >
            <g id="g602" transform="scale(5.5556)">
                <rect id="rect124"
                      style="stroke-width:1pt;fill:#000066"
                      height="90"
                      width="120"
                      y="0"
                      x="0"
                />
                <g id="g584">

                    <path id="path146" style="stroke-width:1pt;fill:#ffffff" d="m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z" />
                    <path id="path136" style="stroke-width:1pt;fill:#ffffff" d="m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z" />
                    <path id="path141" style="stroke-width:1pt;fill:#cc0000" d="m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z" />
                    <path id="path150" style="stroke-width:1pt;fill:#cc0000" d="m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z" />
                </g>
                <polygon id="polygon589" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="30 36 31.736 41.396 37.036 39.389 33.9 44.11 38.774 47.003 33.127 47.494 33.905 53.109 30 49 26.095 53.109 26.873 47.494 21.226 47.003 26.1 44.11 22.964 39.389 28.264 41.396" />
                <g id="g596">
                    <polygon id="polygon590" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="90 45.714 90.826 48.284 93.351 47.328 91.857 49.576 94.178 50.954 91.489 51.188 91.86 53.861 90 51.905 88.14 53.861 88.511 51.188 85.822 50.954 88.143 49.576 86.649 47.328 89.174 48.284" />
                    <polygon id="polygon592" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="90 5.7143 90.826 8.2839 93.351 7.3279 91.857 9.5762 94.178 10.954 91.489 11.188 91.86 13.861 90 11.905 88.14 13.861 88.511 11.188 85.822 10.954 88.143 9.5762 86.649 7.3279 89.174 8.2839" />
                    <polygon id="polygon593" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="75 21.964 75.826 24.534 78.351 23.578 76.857 25.826 79.178 27.204 76.489 27.438 76.86 30.111 75 28.155 73.14 30.111 73.511 27.438 70.822 27.204 73.143 25.826 71.649 23.578 74.174 24.534" />
                    <polygon id="polygon594" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="103.33 17.964 104.16 20.534 106.68 19.578 105.19 21.826 107.51 23.204 104.82 23.438 105.19 26.111 103.33 24.155 101.47 26.111 101.84 23.438 99.155 23.204 101.48 21.826 99.983 19.578 102.51 20.534" />
                    <polygon id="polygon595" style="fill-rule:evenodd;stroke-width:1pt;fill:#ffffff" points="96 30 96.653 31.601 98.378 31.728 97.057 32.843 97.47 34.522 96 33.611 94.53 34.522 94.943 32.843 93.622 31.728 95.347 31.601" />
                </g>
            </g>
        </svg>

    </span>
</template>

<script>
export default {
    props: {
        country: {
            type: String,
            required: true,
            validator: function (value) {
                return [ 'nl', 'gb', 'us', 'de', 'es', 'fr', 'it', 'dk', 'no', 'se', 'fi', 'au' ].indexOf(value) !== -1;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
    .flag-icon {
        width: 1.5em;
        display: inline-block;
        height: 1.125em;
        overflow: hidden;
        position: relative;
        line-height: 1;
        border-radius: .1875em;
        margin-top: -.2em;
    }
</style>
